import React from 'react';
import '../css/separator.css';

const Separator = () => {
  return (
    <div className="separator-container">
      <div className="separator-line"></div>
    </div>
  );
};

export default Separator; 